import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleAdmLogType } from './data';
import { getAdmLogPage, removeAdmLog } from './service';

export type AdmLogState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleAdmLogType[];
};

type AdmLogsModelType = {
  namespace: string;
  state: AdmLogState;
  reducers: {
    AdmLogsReducer: Reducer<AdmLogState>;
  };
  effects: {
    fetchAdmLogsPageEffect: Effect;
    refreshDataEffect: Effect;
    removeAdmLogEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const AdmLogsModel: AdmLogsModelType = {
  namespace: 'admLog',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    AdmLogsReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as AdmLogState;
    },
  },

  effects: {
    *fetchAdmLogsPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getAdmLogPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'AdmLogsReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.admLog.current);
      const pageSize = yield select((state: any) => state.admLog.pageSize);
      yield put({
        type: 'fetchAdmLogsPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: { ...action.sorter },
        },
      });
    },

    removeAdmLogEffect: createEffect(removeAdmLog),
  },

  subscriptions: {
    setup() {},
  },
};

export default AdmLogsModel;
